// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const RUN_OPENTRONS_PROTOCOL_STEP_SHAPES = [
  {
    stepType: PipelineStepType.RUN_OPENTRONS_PROTOCOL,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      protocolFile: {
        systemName: 'protocolFile',
        displayName: 'Protocol file',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: false
      }
    },
    outputDataShapes: {
      outputFiles: {
        systemName: 'outputFiles',
        displayName: 'Output files',
        kind: PipelineStepDataKind.FILE,
        isMulti: true,
        isRequired: false
      }
    },
    config: {
      connectionId: {
        kind: 'string',
        required: true
      },
      protocolId: {
        kind: 'string',
        required: false
      },
      runtimeParameters: {
        kind: 'anything',
        required: false
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
